import { render, staticRenderFns } from "./ProfessionalInfoNurseEdit.vue?vue&type=template&id=05f828c0"
import script from "./ProfessionalInfoNurseEdit.vue?vue&type=script&lang=js"
export * from "./ProfessionalInfoNurseEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports